
import {
  useQuery,
  useMutation,
} from "@tanstack/react-query";
import axios from "axios";
import { constants } from "../constants/constants";
import { BLOG } from "../routes/index.routes";
import { BLOGS_API_ROUTES } from "../routes/api.routes";



const {
  API_URL
} = constants();



export const useGetBlogsData = () => {

  return useQuery({
    queryKey: [BLOG],
    queryFn: async () => {
      const { data } = await axios.get(
        `${API_URL}${BLOGS_API_ROUTES.BLOGS}`,
      )
      return data
    },
  })
};



export const useGetBlogsDataByID = (id) => {

  return useQuery({
    queryKey: [id],
    queryFn: async () => {
      const { data } = await axios.get(
        `${API_URL}${BLOGS_API_ROUTES.BLOGS}/${id}`,
      )
      return data
    },
  })
};


export const useGetBlogsDataBySlug = (slug) => {


  return useQuery({
    queryKey: [slug],
    queryFn: async () => {
      const { data } = await axios.get(
        `${API_URL}${BLOGS_API_ROUTES.BLOGS_SLUGS}/${slug}`,
      )
      return data
    },
  })
};


export const useCreateBlogPost = (data) => {


  return useMutation({
    mutationFn: async () => {
      return await axios.post(`${API_URL}${BLOGS_API_ROUTES.BLOGS}`, data);
    },
  })
};



export const useUpdateBlogPost = (data, id) => {


  return useMutation({
    mutationFn: async () => {
      return await axios.put(`${API_URL}${BLOGS_API_ROUTES.BLOGS}/${id}`, data);
    },
  })
};
